// API Configuration
export const API_BASE_URL = 'https://test-api.tringbox.com/v1';
export const API_ROOT_URL = 'https://test-api.tringbox.com';
export const API_CORE_URL =
  'https://core-api-619357594029.asia-south1.run.app/v1';

// API Endpoints
export const API_ENDPOINTS = {
  // Auth endpoints
  AUTH_REFRESH: `${API_BASE_URL}/auth/refresh`,

  //login endpoints
  SEND_OTP: `${API_BASE_URL}/auth/otp/send`,
  VERIFY_OTP: `${API_BASE_URL}/auth/otp/verify`,
  RESEND_OTP: `${API_BASE_URL}/auth/otp/resend`,

  // User endpoints
  USERS: `${API_BASE_URL}/users`,
  USER_DASHBOARD: `${API_BASE_URL}/users/dashboard`,
  USER_UPLOAD_AVATAR: `${API_BASE_URL}/users/upload/avatar`,
  USER_SUPPORT: `${API_BASE_URL}/users/support`,

  // Config endpoints (no v1 prefix)
  USER_CONFIG: `${API_ROOT_URL}/app/user/config`,

  HOME_PILLS: `${API_BASE_URL}/venue/settings/pills`,
  // Venue endpoints
  VENUES: `${API_BASE_URL}/venue`,
  VENUE_BY_ID: venueId => `${API_BASE_URL}/venues/${venueId}`,
  VENUE_USERS: venueId => `${API_BASE_URL}/venue/${venueId}/users`,
  VENUE_QUEUE: venueId => `${API_BASE_URL}/venue/${venueId}/queue`,
  VENUE_APPROVED: venueId => `${API_BASE_URL}/venue/${venueId}/approved`,
  VENUE_OFFERS: venueId => `${API_BASE_URL}/venue/${venueId}/offers`,
  VENUE_PHOTOS: venueId => `${API_BASE_URL}/venue/${venueId}/photos`,
  VENUE_FAST_TRACK: venueId =>
    `${API_BASE_URL}/venue/${venueId}/queue/fastTrack`,
  VENUE_PLAYBACK: venueId => `${API_BASE_URL}/venue/${venueId}/playback`,
  VENUE_TRACKS: venueId => `${API_BASE_URL}/venue/${venueId}/tracks`,
  VENUE_USERS_COUNT: venueId => `${API_BASE_URL}/venue/${venueId}/users/count`,
  VENUE_SLOTS_AVAILABILITY: venueId =>
    `${API_BASE_URL}/venue/${venueId}/slots-availability`,
  VENUES_CITY: `${API_BASE_URL}/venues/city`,
  VENUES_BY_PARTNER: partnerId => `${API_BASE_URL}/venues/user/${partnerId}`,
  VENUE_ALL_REQUESTS: venueId =>
    `${API_BASE_URL}/venue/${venueId}/requests/all`,
  VENUE_ALL_HISTORY: venueId => `${API_BASE_URL}/venue/${venueId}/played/all`,

  // Music endpoints
  TRACK_SEARCH: `${API_BASE_URL}/track/search`,
  TRACK_TRENDING: `${API_BASE_URL}/track/trending`,
  TRACK_BY_ID: trackId => `${API_BASE_URL}/track/${trackId}`,
  TRACK_BY_ARTIST: artistId => `${API_BASE_URL}/track/artist/${artistId}`,

  // Playlist endpoints
  PLAYLISTS: `${API_BASE_URL}/playlists`,
  PLAYLIST_TRACKS: playlistId =>
    `${API_BASE_URL}/playlist/${playlistId}/tracks`,

  // Artist endpoints
  ARTISTS: `${API_BASE_URL}/artists`,

  // Language endpoints
  LANGUAGES: `${API_BASE_URL}/languages`,

  // Shoutout endpoints
  SHOUTOUT_REQUEST: venueId => `${API_BASE_URL}/shout-out/${venueId}/request`,
  SHOUTOUT_MESSAGES: `${API_BASE_URL}/shout-out/message/thumbnail`,
  SHOUTOUT_USERS_REQUEST: venueId =>
    `${API_BASE_URL}/shout-out/${venueId}/users/request`,
  SHOUTOUT_HISTORY: venueId =>
    `${API_BASE_URL}/shout-out/${venueId}/users/history`,
  SHOUTOUT_PICTURE_UPLOAD: ShoutoutId =>
    `${API_BASE_URL}/shout-out/${ShoutoutId}/upload`,

  // Order endpoints
  ORDER: `${API_BASE_URL}/order`,
  ORDER_PRICE: `${API_BASE_URL}/order/price`,
  ORDER_CONFIG: `${API_BASE_URL}/order/config`,
  ORDER_PRICE_BY_ID: priceId => `${API_BASE_URL}/order/price/${priceId}`,
  ORDER_PRICE_BY_VENUE: venueId =>
    `${API_BASE_URL}/order/price?venueId=${venueId}`,

  // Partner Gift
  PARTNER_GIFT: `${API_BASE_URL}/partner/user/gift`,

  // chance endpoints
  CHANCE_QUESTIONS: `${API_BASE_URL}/chance/questions`,
  CHANCE_ANSWER: `${API_BASE_URL}/chance/answers`,
  CHANCE_USER_ANSWER: `${API_BASE_URL}/chance/answers/my`,
  CHANCE_TAGS: `${API_BASE_URL}/chance/tags`,
  CHANCE_REACTION: `${API_BASE_URL}/chance/reactions`,
  CHANCE_REMOVE_REACTION: `${API_BASE_URL}/chance/reactions/remove`,
  CHANCE_ACTION: `${API_BASE_URL}/chance/action`,
  CHANCE_USER_COMMENT: `${API_BASE_URL}/chance/comments/my`,
  CHANCE_ALL_COMMENTS: questionId =>
    `${API_BASE_URL}/chance/questions/${questionId}/comments`,
  CHANCE_COMMENTS: `${API_BASE_URL}/chance/comments`,

  // Transaction endpoints
  TRANSACTIONS: `${API_BASE_URL}/transactions`,
  TRANSACTIONS_PAYMENTS: `${API_BASE_URL}/transactions/payments`,

  // Rating endpoints
  RATINGS: `${API_BASE_URL}/ratings`,
  RATINGS_BY_ID: id => `${API_BASE_URL}/ratings/${id}`,
  VENUE_RATINGS: venueId => `${API_BASE_URL}/ratings/venue/${venueId}`,

  // Promo code endpoints
  PROMO_CODE: `${API_BASE_URL}/promo-code`,

  // Menu endpoints
  VENUE_MENU: venueId => `${API_BASE_URL}/menu/venue/${venueId}`,
  MENU_ORDER: `${API_BASE_URL}/menu/orders`,

  LIVE_FEED: `${API_BASE_URL}/users/livefeed`,

  // Partner endpoints
  PARTNER_UPLOAD_AVATAR: `${API_BASE_URL}/partner/upload/avatar`,
  USER_REQUEST_RESERVATION: `${API_BASE_URL}/user/request/reservation`,
  PARTNER_USER_GIFT: `${API_BASE_URL}/partner/user/gift`,

  SHOUTOUT_EVENT_HISTORY: eventId =>
    `${API_BASE_URL}/shout-out/event/${eventId}/history`,
};
